  // src/pages/PetRow.js

  import React from 'react';
  import { TableRow, TableCell, IconButton } from '@mui/material';
  import { ArrowForwardIos as ArrowForwardIcon } from '@mui/icons-material';
  import { Link } from 'react-router-dom';
  import CommentsMenu from '../components/CommentsMenu';
  import ImageGalleryDropdown from '../components/ImageGalleryDropdown';
  import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

  function PetRow({ pet, columns, pets }) {
    const showCustomer = columns?.some(col => col.id === 'customer')
    const images = pet.bucket?.images || [];
    return (
      <TableRow>
        {/* Redirect Icon */}
        <TableCell>
          <IconButton
            component={Link}
            to={`/pets/${pet.id}`}
            state={{ records: pets }}
            aria-label="view-details"
          >
            <ArrowForwardIcon sx={{ fontSize: 'small' }} />
          </IconButton>
        </TableCell>
        <TableCell>{pet.name}</TableCell>
        <TableCell>{pet.breed}</TableCell>
        <TableCell>{pet.sex}</TableCell>
        <TableCell>{pet.weight}</TableCell>
        <TableCell>{pet.color}</TableCell>
        <TableCell>{pet.age}</TableCell>
        <TableCell>{pet.medissues}</TableCell>
        {showCustomer &&
          <TableCell>
            {pet.owner
              ? `${pet.owner.firstName} ${pet.owner.lastName}`
              : "No Customer"}
          </TableCell>
        }
        <TableCell>
          <CommentsMenu comments={pet.comments} />
        </TableCell>
        <TableCell>
          {images.length > 1 ? (
            <ImageGalleryDropdown
              images={images}
              onUploadSuccess={null}
              onDelete={null}
              petId={pet.id}
              readOnly={true}
            />
          ) : images.length === 1 ? (
            <a href={images[0].imageUrl} target="_blank" rel="noopener noreferrer">
              <IconButton aria-label="view image">
                <PhotoLibraryIcon sx={{ fontSize: '18px', color: 'primary.main' }} />
              </IconButton>
            </a>
          ) : null}
        </TableCell>
      </TableRow>
    );
  }

  export default PetRow;